import axios from "axios";
import { BACKEND_URL } from "../../config/api";
import { CountrySender, CountrySenderStatus } from "../../types/features/administration/CountrySender";

export const countrySenderService = {
  async getCountrySenders(token: string, skip = 0, limit = 100, includeDestinations = true): Promise<CountrySender[]> {
    const response = await axios.get(
      `${BACKEND_URL}/country-sender/?skip=${skip}&limit=${limit}&include_destinations=${includeDestinations}`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return response.data.data.country_senders;
  },

  async createCountrySender(
    token: string,
    data: { country_id: number; status: CountrySenderStatus; default_daily_limit?: number | null }
  ): Promise<void> {
    await axios.post(`${BACKEND_URL}/country-sender/`, data, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },

  async updateCountrySender(
    token: string,
    senderId: number,
    data: { status?: CountrySenderStatus; default_daily_limit?: number | null }
  ): Promise<void> {
    await axios.put(`${BACKEND_URL}/country-sender/${senderId}`, data, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },

  async deleteCountrySender(token: string, senderId: number): Promise<void> {
    await axios.delete(`${BACKEND_URL}/country-sender/${senderId}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },

  async addDestination(
    token: string,
    senderId: number,
    data: { country_destination_id: number; status: CountrySenderStatus }
  ): Promise<void> {
    await axios.post(`${BACKEND_URL}/country-sender/${senderId}/destinations`, data, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },

  async updateDestination(token: string, destinationId: number, data: { status: CountrySenderStatus }): Promise<void> {
    await axios.put(`${BACKEND_URL}/country-sender/destinations/${destinationId}`, data, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },

  async deleteDestination(token: string, destinationId: number): Promise<void> {
    await axios.delete(`${BACKEND_URL}/country-sender/destinations/${destinationId}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },
};
